<template>
  <div class="wrap">
    <Header />
    <router-view />
    <Footer />
    <QuickMenu />
  </div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import QuickMenu from "@/components/common/QuickMenu.vue";

export default {
  components: {
    Header,
    Footer,
    QuickMenu,
  },
};
</script>
<style scoped>
</style>